import {SET_TEAMS_AND_USERS} from '../actionTypes'

const initialState = []

/**
 * This is added for the team / user lookup.
 * We could have used teams reducer, but the user reducer has some 6 yr old code in it 
 * and not sure what it is used for 
 */

export default (state=initialState,  payload) => {
    switch(payload.type) {
    case SET_TEAMS_AND_USERS:
        return payload.teamsAndUsers || initialState
    default:
        return state
    }
}